import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import styles from './SetUpReady.module.css'
import {
    fetchAgentDetailById,
    calenderCheck,
    getAgentSpamSettings,
    updateAgentSpamSettings,
    getAgentSettingsSection,
} from '../../Store/apiStore'
import { fetchSetupScore } from '../../lib/setupScore'
import decodeToken from '../../lib/decodeToken'
import { trackEvent } from '../../lib/analytics'
import PopUp from '../Popup/Popup'

/* Green check icon shown on completed steps. */
const CheckIcon = () => (
    <span className={`${styles.statusIcon} ${styles.done}`}>
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="5.93815" cy="5.9362" r="4.35417" fill="white" />
            <path d="M10.992 5.49599C10.992 8.53135 8.53135 10.992 5.49599 10.992C2.46064 10.992 0 8.53135 0 5.49599C0 2.46064 2.46064 0 5.49599 0C8.53135 0 10.992 2.46064 10.992 5.49599ZM8.26482 3.41416C8.0636 3.21294 7.73737 3.21294 7.53615 3.41416C7.53129 3.41902 7.52672 3.42417 7.52248 3.42957L5.13696 6.46929L3.69872 5.03105C3.4975 4.82983 3.17126 4.82983 2.97005 5.03105C2.76883 5.23226 2.76883 5.5585 2.97005 5.75972L4.78815 7.57783C4.98937 7.77904 5.31561 7.77904 5.51683 7.57783C5.52131 7.57335 5.52554 7.56862 5.52949 7.56367L8.27213 4.13537C8.46601 3.93363 8.46357 3.61291 8.26482 3.41416Z" fill="#27B75E" />
        </svg>

    </span>
)

/* Orange cross icon shown on pending steps. */
const PendingIcon = () => (
    <span className={`${styles.statusIcon} ${styles.pending}`}>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="6" cy="6" r="6" fill="#FDBA2E" />
            <path d="M8.54028 9.46195C8.45187 8.05496 7.49411 7.26941 6.4833 6.56188C7.52358 5.83282 8.50786 5.02037 8.54617 3.53805H9V3H3V3.53805H3.45383C3.49214 5.02037 4.47642 5.83282 5.5167 6.56188C4.50589 7.26941 3.54813 8.05496 3.45972 9.46195H3V10H9V9.46195H8.54028ZM6 6.90085C6.97544 7.57879 7.85363 8.25404 7.95088 9.46195H4.04912C4.14637 8.25404 5.02456 7.57879 6 6.90085Z" fill="white" />
        </svg>

    </span>
)

const AvailabilityValueStatus = ({ enabled }) => (
    <span
        className={`${styles.valueStatusIcon} ${enabled ? styles.valueStatusEnabled : styles.valueStatusDisabled}`}
        aria-label={enabled ? '24/7 enabled' : '24/7 disabled'}
        title={enabled ? '24/7 enabled' : '24/7 disabled'}
    >
        {enabled ? (
            <svg viewBox="0 0 12 12" fill="none" aria-hidden="true">
                <path d="M3 6.2l1.8 1.8L9 3.8" />
            </svg>
        ) : (
            <svg viewBox="0 0 12 12" fill="none" aria-hidden="true">
                <path d="M3.5 3.5l5 5M8.5 3.5l-5 5" />
            </svg>
        )}
    </span>
)

/* ---- Card icons (inline SVG) ---- */
const PhoneIcon = () => (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="19" cy="19" r="19" fill="#E6F8F0" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7057 13.4598C13.2467 12.818 14.0279 12.4055 14.8168 12.1524C15.3147 11.9925 15.8152 12.2604 16.0471 12.7101L17.1085 14.7666C17.6816 15.8775 16.7024 16.1062 16.0182 17.1258C15.8666 17.352 15.6765 17.7002 15.8351 17.9694C17.2068 20.299 18.8064 21.8988 21.1359 23.2703C21.6197 23.5549 22.4414 22.7306 22.7504 22.4203C23.2882 21.8793 23.6184 21.6249 24.3392 21.9969L26.3957 23.0583C26.8455 23.2902 27.1134 23.7907 26.9534 24.2886C26.4446 25.8729 25.3897 27.1271 23.6145 27.1052C19.0923 27.0499 12.0555 20.013 12.0003 15.4913C11.9913 14.7358 12.2168 14.0401 12.7057 13.4598ZM19.9525 13.0532C23.3215 13.0532 26.052 15.7837 26.052 19.1528C26.052 19.7766 26.9996 19.7766 26.9996 19.1528C26.9996 15.2607 23.8445 12.1055 19.9525 12.1055C19.3287 12.1055 19.3287 13.0532 19.9525 13.0532ZM19.9525 17.6546C20.78 17.6546 21.4507 18.3253 21.4507 19.1528C21.4507 19.7767 22.3984 19.7767 22.3984 19.1528C22.3984 17.8024 21.3036 16.707 19.9525 16.707C19.3287 16.707 19.3287 17.6546 19.9525 17.6546ZM19.9525 15.3539C22.0508 15.3539 23.7514 17.0546 23.7514 19.1529C23.7514 19.7768 24.699 19.7768 24.699 19.1529C24.699 16.5316 22.5738 14.4064 19.9526 14.4064C19.3288 14.4064 19.3287 15.3539 19.9525 15.3539Z" fill="#27B75E" />
    </svg>

)

const ForwardIcon = () => (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="19" cy="19" r="19" fill="#E6F8F0" />
        <path d="M26.9809 27.7673L26.1811 25.4705C26.1091 25.2164 25.9867 24.9803 25.8215 24.777C25.6564 24.5738 25.452 24.4077 25.2213 24.2893L20.6013 22.2648L20.4829 21.4577C21.0901 21.1404 21.6251 20.6952 22.0529 20.1513C22.4808 19.6073 22.7918 18.9769 22.9657 18.3012H23.8935C24.1246 18.2977 24.3451 18.2012 24.5074 18.0323C24.6696 17.8635 24.7606 17.6359 24.7605 17.3989C24.7605 16.7426 24.7605 15.7583 24.7605 15.1021C24.4406 7.24695 13.5626 7.24367 13.2427 15.0824C13.2427 15.4827 13.2427 16.3948 13.2427 16.7853V17.389C13.2427 17.6283 13.3354 17.8578 13.5004 18.0271C13.6654 18.1963 13.8891 18.2913 14.1225 18.2913H15.0503C15.2242 18.9671 15.5352 19.5975 15.9631 20.1414C16.3909 20.6854 16.9259 21.1305 17.5331 21.4478L17.4019 22.2648L12.7787 24.2893C12.548 24.4077 12.3436 24.5738 12.1785 24.777C12.0133 24.9803 11.8909 25.2164 11.8189 25.4705L11.0191 27.7673C11.0015 27.8171 10.996 27.8706 11.0029 27.923C11.0098 27.9755 11.0291 28.0255 11.0589 28.0687C11.0888 28.1119 11.1284 28.147 11.1744 28.1711C11.2204 28.1952 11.2714 28.2075 11.323 28.207H26.6802C26.7316 28.207 26.7822 28.1943 26.8277 28.17C26.8733 28.1457 26.9125 28.1105 26.942 28.0673C26.9715 28.0242 26.9904 27.9744 26.9972 27.9222C27.004 27.87 26.9984 27.8169 26.9809 27.7673ZM14.9064 15.2989C14.5616 15.2851 14.2162 15.2961 13.8729 15.3317V15.0824C14.1545 8.11318 23.8487 8.11646 24.1207 15.0824V15.312C24.0439 15.2924 23.0873 15.2792 23.0873 15.2792C22.6617 12.9562 20.9884 11.2106 19.0016 11.2106C17.0148 11.2106 15.3415 12.9562 14.9064 15.2891V15.2989ZM19.7471 23.2393C19.605 23.3958 19.4183 23.5023 19.2137 23.5434C19.0091 23.5845 18.797 23.5583 18.6078 23.4684C18.4186 23.3785 18.262 23.2295 18.1604 23.0428C18.0587 22.8561 18.0172 22.6412 18.0418 22.4289L18.1538 21.6841C18.7185 21.8317 19.3103 21.8317 19.875 21.6841C19.9262 22.1631 20.1342 22.8456 19.7471 23.2393ZM20.035 20.9425C17.8178 21.7989 15.8214 19.7646 15.5046 17.4317C15.9223 17.6436 16.3864 17.7408 16.8516 17.7139C18.4513 17.4415 19.0016 16.8247 19.4751 16.28C19.6447 16.0671 19.8392 15.8765 20.0542 15.7123C20.1454 15.6503 20.2552 15.6237 20.3638 15.6376C20.4724 15.6514 20.5725 15.7047 20.6461 15.7878C21.1948 16.2848 21.8539 16.6363 22.5657 16.8115C22.521 18.5374 21.4747 20.4208 20.035 20.9425Z" fill="#27B75E" />
    </svg>

)

const TriageIcon = () => (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="19" cy="19" r="19" fill="#FEF9EE" />
        <path d="M29.0021 16.4094C29.0064 17.519 28.7521 18.6144 28.2593 19.6087C27.7665 20.6029 27.0488 21.4686 26.1632 22.1372C26.0879 22.1945 25.9929 22.2196 25.8991 22.2068C25.8054 22.1941 25.7205 22.1446 25.6632 22.0693C25.6059 21.994 25.5808 21.899 25.5935 21.8052C25.6063 21.7115 25.6557 21.6266 25.731 21.5693C30.6498 17.8364 27.9613 9.91225 21.7888 9.91047C20.7869 9.90616 19.7978 10.1357 18.9002 10.5808C18.0026 11.0258 17.2212 11.6742 16.6182 12.4743C16.5609 12.5501 16.4758 12.6 16.3817 12.6131C16.2876 12.6261 16.1922 12.6013 16.1164 12.544C16.0406 12.4867 15.9907 12.4016 15.9776 12.3075C15.9646 12.2134 15.9894 12.1179 16.0467 12.0421C20.1893 6.57509 28.9978 9.549 29.0021 16.4094ZM26.5133 25.2186C26.4472 27.0002 27.0369 29.3616 24.2955 29.1433C16.1985 29.2998 8.70734 21.3328 9.0088 13.438C9.1106 11.3688 11.0151 11.6807 12.2652 11.6707C13.1803 11.7325 14.1694 11.4314 14.9648 12.1421C15.7346 12.9076 15.417 13.9416 15.6185 14.831C15.7249 15.8501 16.4621 16.8827 15.6292 17.9056C15.2038 18.4686 14.7305 19.0611 14.329 19.6269C15.2841 21.4251 16.7553 22.8963 18.5534 23.8513C19.1489 23.4256 19.7018 22.988 20.2822 22.544C20.6264 22.2594 21.0689 22.1221 21.5138 22.1618C22.1853 22.244 22.8203 22.5201 23.4672 22.5762C23.7321 22.6269 24.0011 22.6532 24.2709 22.6548C25.9982 22.5944 26.6697 23.5752 26.5133 25.2186Z" fill="#FDBA2E" />
        <path d="M23.1567 13.8764V15.0369H24.3175C24.5465 15.0378 24.7658 15.1291 24.9277 15.2911C25.0895 15.453 25.1808 15.6724 25.1815 15.9013V16.9118C25.1813 17.1409 25.0902 17.3607 24.9281 17.5227C24.7661 17.6847 24.5463 17.7757 24.3172 17.7758H23.1567V18.9366C23.1565 19.1658 23.0653 19.3855 22.9033 19.5475C22.7412 19.7095 22.5214 19.8006 22.2923 19.8007H21.2822C21.0532 19.7999 20.8337 19.7086 20.6718 19.5467C20.5099 19.3847 20.4185 19.1653 20.4178 18.9363V17.7758H19.2573C19.144 17.7757 19.0318 17.7532 18.9272 17.7097C18.8226 17.6661 18.7276 17.6024 18.6477 17.5221C18.5677 17.4418 18.5044 17.3466 18.4613 17.2418C18.4182 17.137 18.3962 17.0247 18.3965 16.9114V15.901C18.3966 15.6724 18.4872 15.4532 18.6485 15.2912C18.8098 15.1293 19.0287 15.0379 19.2573 15.0369H20.4181V13.8761C20.4192 13.6476 20.5107 13.4288 20.6726 13.2675C20.8345 13.1063 21.0537 13.0157 21.2822 13.0156H22.2926C22.4059 13.0153 22.5182 13.0373 22.623 13.0804C22.7278 13.1235 22.823 13.1869 22.9033 13.2668C22.9836 13.3468 23.0473 13.4418 23.0909 13.5464C23.1344 13.651 23.1565 13.7631 23.1567 13.8764Z" fill="#FDBA2E" />
    </svg>

)

const CalendarIcon = () => (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="19" cy="19" r="19" fill="#E6F8F0" />
        <path d="M11.0742 13.8837V25.3584C11.0742 26.116 11.7606 26.7297 12.608 26.7297H25.4427C26.2901 26.7297 26.9765 26.116 26.9765 25.3584V13.8837C26.9765 13.1261 26.2901 12.5124 25.4427 12.5124H23.7809V11.8138C23.7809 11.4792 23.4765 11.207 23.1023 11.207C22.728 11.207 22.4236 11.4792 22.4236 11.8138V12.5124H15.6272V11.8138C15.6272 11.4792 15.3227 11.207 14.9485 11.207C14.5742 11.207 14.2698 11.4792 14.2698 11.8138V12.5124H12.608C11.7606 12.5124 11.0742 13.1261 11.0742 13.8837ZM22.4236 13.667V14.5823C22.4236 14.9169 22.728 15.1891 23.1023 15.1891C23.4765 15.1891 23.7809 14.9169 23.7809 14.5823V13.667C24.1125 13.8646 24.3316 14.201 24.3316 14.5823C24.3316 15.1891 23.7809 15.6815 23.1023 15.6815C22.4236 15.6815 21.8729 15.1891 21.8729 14.5823C21.8729 14.1992 22.092 13.8629 22.4236 13.667ZM14.2698 13.667V14.5823C14.2698 14.9169 14.5742 15.1891 14.9485 15.1891C15.3227 15.1891 15.6272 14.9169 15.6272 14.5823V13.667C15.9587 13.8646 16.1778 14.201 16.1778 14.5823C16.1778 15.1891 15.6272 15.6815 14.9485 15.6815C14.2698 15.6815 13.7191 15.1891 13.7191 14.5823C13.7191 14.1992 13.9382 13.8629 14.2698 13.667ZM13.215 16.7112H24.8377C25.2605 16.7112 25.6037 17.0181 25.6037 17.396V24.8141C25.6037 25.192 25.2605 25.4988 24.8377 25.4988H13.213C12.7903 25.4988 12.4471 25.192 12.4471 24.8141V17.3977C12.4471 17.0198 12.7903 16.7129 13.213 16.7129L13.215 16.7112Z" fill="#27B75E" />
        <path d="M18.0104 17.5312H17.004C16.8626 17.5312 16.748 17.6337 16.748 17.7601V18.6598C16.748 18.7862 16.8626 18.8887 17.004 18.8887H18.0104C18.1517 18.8887 18.2663 18.7862 18.2663 18.6598V17.7601C18.2663 17.6337 18.1517 17.5312 18.0104 17.5312Z" fill="#27B75E" />
        <path d="M21.0436 17.5312H20.0372C19.8958 17.5312 19.7812 17.6337 19.7812 17.7601V18.6598C19.7812 18.7862 19.8958 18.8887 20.0372 18.8887H21.0436C21.1849 18.8887 21.2995 18.7862 21.2995 18.6598V17.7601C21.2995 17.6337 21.1849 17.5312 21.0436 17.5312Z" fill="#27B75E" />
        <path d="M24.0807 17.5312H23.0743C22.933 17.5312 22.8184 17.6337 22.8184 17.7601V18.6598C22.8184 18.7862 22.933 18.8887 23.0743 18.8887H24.0807C24.2221 18.8887 24.3367 18.7862 24.3367 18.6598V17.7601C24.3367 17.6337 24.2221 17.5312 24.0807 17.5312Z" fill="#27B75E" />
        <path d="M14.9733 20.2266H13.9669C13.8255 20.2266 13.7109 20.329 13.7109 20.4554V21.3551C13.7109 21.4815 13.8255 21.584 13.9669 21.584H14.9733C15.1146 21.584 15.2292 21.4815 15.2292 21.3551V20.4554C15.2292 20.329 15.1146 20.2266 14.9733 20.2266Z" fill="#27B75E" />
        <path d="M18.0104 20.2266H17.004C16.8626 20.2266 16.748 20.329 16.748 20.4554V21.3551C16.748 21.4815 16.8626 21.584 17.004 21.584H18.0104C18.1517 21.584 18.2663 21.4815 18.2663 21.3551V20.4554C18.2663 20.329 18.1517 20.2266 18.0104 20.2266Z" fill="#27B75E" />
        <path d="M21.0436 20.2266H20.0372C19.8958 20.2266 19.7812 20.329 19.7812 20.4554V21.3551C19.7812 21.4815 19.8958 21.584 20.0372 21.584H21.0436C21.1849 21.584 21.2995 21.4815 21.2995 21.3551V20.4554C21.2995 20.329 21.1849 20.2266 21.0436 20.2266Z" fill="#27B75E" />
        <path d="M24.0807 20.2266H23.0743C22.933 20.2266 22.8184 20.329 22.8184 20.4554V21.3551C22.8184 21.4815 22.933 21.584 23.0743 21.584H24.0807C24.2221 21.584 24.3367 21.4815 24.3367 21.3551V20.4554C24.3367 20.329 24.2221 20.2266 24.0807 20.2266Z" fill="#27B75E" />
        <path d="M14.9733 22.918H13.9669C13.8255 22.918 13.7109 23.0204 13.7109 23.1468V24.0465C13.7109 24.1729 13.8255 24.2754 13.9669 24.2754H14.9733C15.1146 24.2754 15.2292 24.1729 15.2292 24.0465V23.1468C15.2292 23.0204 15.1146 22.918 14.9733 22.918Z" fill="#27B75E" />
        <path d="M18.0084 22.918H17.0021C16.8607 22.918 16.7461 23.0204 16.7461 23.1468V24.0465C16.7461 24.1729 16.8607 24.2754 17.0021 24.2754H18.0084C18.1498 24.2754 18.2644 24.1729 18.2644 24.0465V23.1468C18.2644 23.0204 18.1498 22.918 18.0084 22.918Z" fill="#27B75E" />
        <path d="M21.0436 22.918H20.0372C19.8958 22.918 19.7812 23.0204 19.7812 23.1468V24.0465C19.7812 24.1729 19.8958 24.2754 20.0372 24.2754H21.0436C21.1849 24.2754 21.2995 24.1729 21.2995 24.0465V23.1468C21.2995 23.0204 21.1849 22.918 21.0436 22.918Z" fill="#27B75E" />
    </svg>

)

const ShieldIcon = () => (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="19" cy="19" r="19" fill="#FEF9EE" />
        <path d="M26.5597 12.0076L19.226 9.24875C19.0793 9.19312 18.9198 9.19312 18.773 9.24875L11.4402 12.0076C11.1768 12.1076 11 12.3659 11 12.6563V16.2419C11 21.7379 13.9505 26.6763 18.7038 29.1344C18.7968 29.1825 18.897 29.207 19 29.207C19.103 29.207 19.2033 29.1825 19.2962 29.1344C24.0495 26.6753 27 21.7376 27 16.2419V12.6563C27 12.3669 26.8231 12.1085 26.5597 12.0076ZM23.3369 16.556L18.817 21.9181C18.6903 22.0699 18.5071 22.1557 18.3139 22.1557H18.3102C18.1133 22.1519 17.9301 22.0661 17.8071 21.9105L14.9933 18.4833C14.7536 18.1901 14.7864 17.7554 15.0699 17.5112C15.3497 17.2633 15.7699 17.301 16.0069 17.5904L18.3202 20.4077L22.3307 15.6529C22.5741 15.3635 22.9943 15.3361 23.2704 15.5841C23.5502 15.8359 23.5766 16.2703 23.3369 16.556Z" fill="#FDBA2E" />
    </svg>

)

const ClockIcon = () => (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="19" cy="19" r="19" fill="#E6F8F0" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.3769 12.2111C20.5149 12.304 21.5837 12.6437 22.5295 13.1764L23.1141 12.4992C23.1954 12.4056 23.3342 12.3947 23.4283 12.4763L24.7724 13.6391C24.865 13.7193 24.8755 13.8603 24.7954 13.9533L24.2928 14.5356C25.6463 15.9295 26.48 17.8304 26.48 19.9247C26.48 24.1961 23.0114 27.6647 18.74 27.6647C14.4686 27.6647 11 24.1961 11 19.9247C11 15.8678 14.1289 12.5354 18.1031 12.2111V11.4809H17.292C17.1694 11.4809 17.0693 11.3808 17.0693 11.2581V10.4297C17.0693 10.3071 17.1694 10.207 17.292 10.207H20.188C20.3107 10.207 20.4107 10.3071 20.4107 10.4297V11.2581C20.4107 11.3808 20.3107 11.4809 20.188 11.4809H19.3769V12.2111ZM18.74 13.3314C15.0965 13.3314 12.1467 16.2812 12.1467 19.9247C12.1467 23.5683 15.0965 26.5181 18.74 26.5181C22.3835 26.5181 25.3333 23.5683 25.3333 19.9247C25.3333 16.2812 22.3835 13.3314 18.74 13.3314Z" fill="#27B75E" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7235 19.9266V14.0391C15.4716 14.0391 12.8359 16.6751 12.8359 19.9266C12.8359 23.1782 15.4716 25.8142 18.7235 25.8142C20.7054 25.8142 22.554 24.8169 23.6431 23.1609L18.7235 19.9266Z" fill="#27B75E" />
    </svg>

)

/* ---- Phone-number helpers (mirror FastAgentDetails' Setup Summary parsing) ----
 * voip_numbers can arrive as a JSON string of an array, an already-parsed
 * array of strings/objects, or a bare string. Pull the first usable number
 * out regardless of wrapper, then pretty-format it as "+1 234-567-8901". */
const extractFirstNumber = (firstItem) => {
    if (!firstItem) return ''
    if (typeof firstItem === 'string') return firstItem.trim()
    if (typeof firstItem === 'object') {
        return (
            firstItem.phoneNumber ||
            firstItem.number ||
            firstItem.voipNumber ||
            firstItem.phone_number ||
            ''
        )
    }
    return ''
}

const extractVoipNumber = (v) => {
    if (!v) return ''
    if (Array.isArray(v)) return extractFirstNumber(v[0])
    if (typeof v === 'string') {
        const trimmed = v.trim()
        if (trimmed.startsWith('[')) {
            try {
                const parsed = JSON.parse(trimmed)
                if (Array.isArray(parsed)) return extractFirstNumber(parsed[0])
                return extractFirstNumber(parsed)
            } catch {
                return trimmed
            }
        }
        return trimmed
    }
    if (typeof v === 'object') return extractFirstNumber(v)
    return ''
}

const formatPhone = (num) => {
    const cleaned = String(num || '').replace(/\D/g, '')
    if (cleaned.length < 10) return String(num || '')
    const last10 = cleaned.slice(-10)
    const cc = cleaned.length > 10 ? cleaned.slice(0, cleaned.length - 10) : '1'
    return `+${cc} ${last10.slice(0, 3)}-${last10.slice(3, 6)}-${last10.slice(6)}`
}

// Stable public deep links used by notification emails and mobile webviews.
// Each slug resolves through this page first so live status and prerequisites
// are checked before the existing feature screen is opened.
export const SETUP_READY_FEATURE_PATHS = {
    phoneNumber: '/setup-ready/ai-local-number',
    callForwarding: '/setup-ready/call-forwarding',
    callTriage: '/setup-ready/call-triage',
    calendar: '/setup-ready/calendar',
    spamFiltering: '/setup-ready/spam-filtering',
    availability: '/setup-ready/availability',
}

const FEATURE_KEY_BY_SLUG = {
    'ai-local-number': 'phoneNumber',
    'call-forwarding': 'callForwarding',
    'call-triage': 'callTriage',
    calendar: 'calendar',
    'spam-filtering': 'spamFiltering',
    availability: 'availability',
}

const SetUpReady = ({ agentName: agentNameProp = 'Sofia', percent: percentProp }) => {
    const navigate = useNavigate()
    const location = useLocation()
    const { featureSlug } = useParams()
    const deepLinkHandledRef = useRef(false)

    // When this screen is opened from Great Progress, start with the exact
    // score already shown there. This prevents the old hardcoded 60% from
    // flashing before the fresh setup-score request finishes.
    const initialPercent = Number.isFinite(Number(location?.state?.setupPercent))
        ? Number(location.state.setupPercent)
        : Number.isFinite(Number(percentProp))
            ? Number(percentProp)
            : 0

    // ---- Identity / lookup keys — same sources FastAgentDetails uses ----
    const token =
        typeof window !== 'undefined' ? localStorage.getItem('token') || '' : ''
    const decoded = token ? decodeToken(token) : null
    const query = new URLSearchParams(location.search)
    const userId =
        query.get('userId') ||
        (typeof window !== 'undefined' && localStorage.getItem('teamOwnerId')) ||
        decoded?.id
    const agentId =
        location?.state?.agentId ||
        query.get('agentId') ||
        (typeof window !== 'undefined'
            ? sessionStorage.getItem('SelectAgentId')
            : null)
    const bussinesId =
        location?.state?.bussinesId ||
        query.get('businessId') ||
        query.get('bussinesId') ||
        (typeof window !== 'undefined'
            ? sessionStorage.getItem('SelectAgentBusinessId')
            : null)

    // Calendar connected from this screen's Calendar card: /calendar-access
    // starts Google OAuth with returnTo '/setup-ready', so the callback lands
    // back HERE with ?googleAuth=success (only appended after the tokens are
    // stored). No other screen sees that return, so without this the connect
    // was never tracked. The once-per-user guard in trackEvent stops a refresh
    // from counting it twice.
    useEffect(() => {
        if (new URLSearchParams(location.search).get('googleAuth') !== 'success') return
        trackEvent('calendar_sync_completed', { source: 'setup_ready' })
    }, [location.search])

    // ---- Live status (fetched) ----
    const [loading, setLoading] = useState(true)
    const [steps, setSteps] = useState([])
    const [agentName, setAgentName] = useState(agentNameProp)
    const [percent, setPercent] = useState(initialPercent)
    const [sequencePopupMessage, setSequencePopupMessage] = useState('')
    // Full agent spam-settings object (kept so the inline "Auto Spam Blocking"
    // toggle can preserve sibling fields — notifyPush, forwardNumber, etc. —
    // when it flips autoBlacklistEnabled, mirroring the /contacts screen.
    const [spamSettings, setSpamSettings] = useState({})
    const [spamSaving, setSpamSaving] = useState(false)

    // ---- Animated progress ring ----
    const size = 110
    const stroke = 8
    const radius = (size - stroke) / 2
    const circumference = 2 * Math.PI * radius
    const [progress, setProgress] = useState(0)

    useEffect(() => {
        const id = requestAnimationFrame(() => setProgress(percent))
        return () => cancelAnimationFrame(id)
    }, [percent])

    const offset = circumference - (progress / 100) * circumference

    // ---- Fetch real per-feature status and build the dynamic step list.
    //      Each source is best-effort — a failed call degrades that row to
    //      "Pending" (which shows Setup now) rather than blocking the screen.
    //      APIs mirror FastAgentDetails' Setup Summary dialog:
    //        phone      → fetchAgentDetailById → agent.voip_numbers
    //        forwarding → fetchSetupScore.steps.callForwardingDone / agent.callForwarding
    //        triage     → fetchSetupScore.steps.triageRulesSaved
    //        calendar   → calenderCheck(userId).data.connected
    //        spam       → getAgentSpamSettings(agentId).autoBlacklistEnabled
    //        availability → always on (24/7) until Business Hours is customised
    useEffect(() => {
        let cancelled = false
        ;(async () => {
            if (!agentId) {
                setLoading(false)
                return
            }
            try {
                const [agentBody, calRes, spamRes, scoreRes, availabilityRes] = await Promise.all([
                    fetchAgentDetailById({ agentId, bussinesId }).catch(() => null),
                    userId ? calenderCheck(userId).catch(() => null) : Promise.resolve(null),
                    getAgentSpamSettings(agentId).catch(() => ({})),
                    fetchSetupScore(agentId).catch(() => null),
                    getAgentSettingsSection(agentId, 'availability').catch(() => null),
                ])
                if (cancelled) return

                const agent = agentBody?.data?.agent || null

                const rawPhone = extractVoipNumber(agent?.voip_numbers)
                const hasNumber = !!rawPhone
                const phoneNumber = hasNumber ? formatPhone(rawPhone) : ''

                const forwardingDone =
                    !!scoreRes?.steps?.callForwardingDone?.done || !!agent?.callForwarding
                const triageDone = !!scoreRes?.steps?.triageRulesSaved?.done
                const calendarConnected = !!calRes?.data?.connected
                const spamEnabled = !!spamRes?.autoBlacklistEnabled
                // Stash the full settings object so the inline toggle can
                // spread it when flipping autoBlacklistEnabled.
                setSpamSettings(spamRes && typeof spamRes === 'object' ? spamRes : {})
                // Agent Schedule treats missing legacy settings as enabled;
                // mirror that exact behavior here for backward compatibility.
                const is24x7 = availabilityRes?.is24x7 !== false

                setAgentName(agent?.agentName || agentNameProp)
                if (typeof scoreRes?.percent === 'number') setPercent(scoreRes.percent)

                setSteps([
                    {
                        key: 'phoneNumber',
                        icon: <PhoneIcon />,
                        title: 'AI Local phone number',
                        done: hasNumber,
                        value: hasNumber ? phoneNumber : 'Pending',
                        route: '/go-live-setup',
                        wizardStep: 1,
                        returnTo: '/setup-ready',
                    },
                    {
                        key: 'callForwarding',
                        icon: <ForwardIcon />,
                        title: 'Business call forwarding',
                        done: forwardingDone,
                        value: forwardingDone ? 'Configured' : 'Pending',
                        route: '/go-live-setup',
                        wizardStep: 2,
                        prerequisites: ['phoneNumber'],
                        returnTo: '/setup-ready',
                    },
                    {
                        key: 'callTriage',
                        icon: <TriageIcon />,
                        title: 'Internal Call Triage',
                        done: triageDone,
                        value: triageDone ? 'Configured' : 'Pending',
                        route: '/go-live-setup',
                        wizardStep: 4,
                        // Triage and forwarding are independent after a local
                        // number exists; triage does not require forwarding.
                        prerequisites: ['phoneNumber'],
                        returnTo: '/setup-ready',
                    },
                    {
                        key: 'calendar',
                        icon: <CalendarIcon />,
                        title: 'Calendar',
                        done: calendarConnected,
                        value: calendarConnected ? 'Connected' : 'Pending',
                        valueSuffix: calendarConnected ? ' - Google Cal.' : undefined,
                        route: '/calendar-access',
                        returnTo: '/setup-ready',
                    },
                    {
                        key: 'spamFiltering',
                        icon: <ShieldIcon />,
                        title: 'Turn on spam filtering',
                        done: spamEnabled,
                        value: spamEnabled ? 'Enabled' : 'Pending',
                        // Toggled inline (same Auto Spam Blocking control as the
                        // /contacts Blacklist tab) instead of navigating away.
                        // "Manage" still deep-links to /contacts for the full list.
                        toggle: true,
                        route: '/contacts',
                        returnTo: '/setup-ready',
                    },
                    {
                        key: 'availability',
                        icon: <ClockIcon />,
                        title: 'Availability',
                        done: true,
                        value: '24/7',
                        valueStatus: <AvailabilityValueStatus enabled={is24x7} />,
                        route: '/Business_hours',
                        // Always reachable (24/7) so it's never "pending" — but it
                        // stays editable, so it shows "Update" instead of no button.
                        updatable: true,
                        returnTo: '/setup-ready',
                    },
                ])
            } catch (_e) {
                /* best-effort — leave steps empty on hard failure */
            } finally {
                if (!cancelled) setLoading(false)
            }
        })()
        return () => {
            cancelled = true
        }
    }, [agentId, bussinesId, userId, agentNameProp])

    // The first three setup features are a strict sequence:
    // phone number -> call forwarding -> internal call triage.
    // Only guard entry here; the existing destination screens and their
    // completion logic remain unchanged.
    const handleStepAction = useCallback((step) => {
        const prerequisites = step.prerequisites || []
        const firstIncomplete = prerequisites
            .map((key) => steps.find((candidate) => candidate.key === key))
            .find((candidate) => !candidate?.done)

        if (firstIncomplete) {
            setSequencePopupMessage(
                `You must complete the previous step ${firstIncomplete.title} to access this.`
            )
            return
        }

        if (!step.route) return

        // Persist context for every destination, not only wizard routes. This
        // is required when a cold mobile webview was opened from an email URL
        // carrying agentId/businessId query parameters.
        try {
            if (agentId) sessionStorage.setItem('SelectAgentId', agentId)
            if (bussinesId) {
                sessionStorage.setItem('SelectAgentBusinessId', bussinesId)
            }
            // Completing a step from here can route through the go-live wizard,
            // which arms the "is Live" Setup Summary popup on /fast-agent-detail.
            // That celebration is a one-time onboarding moment — it must NOT
            // re-appear when the user is just finishing a step from Setup Ready.
            // FastAgentDetails consumes this marker to keep the popup closed.
            sessionStorage.setItem('setupReady.suppressSetupSummary', 'true')
            sessionStorage.setItem('setupReady.returnTo', '/setup-ready')
        } catch (_e) {
            // Destination screens keep their existing context fallback.
        }

        // Reuse the exact paid-dashboard number wizard for the first three
        // sequence features. Supplying the internal step lets each Setup Ready
        // entry open at the correct point while keeping the wizard's existing
        // Number -> Carrier/Forwarding -> Triage transitions intact.
        if (step.route === '/go-live-setup' && step.wizardStep) {
            try {
                // Setup Ready drives the Number -> Forwarding -> Triage ->
                // Add-ons ladder, so clear any standalone dashboard marker
                // (that one finishes to /fast-agent-detail and would skip the
                // add-ons dialog on Triage).
                //
                // The ladder is no longer run to its end unconditionally: the
                // wizard checks the setup score as it leaves each feature and
                // returns here once nothing downstream is still pending — see
                // `advancePastFeature` in GoLiveWizard.jsx. Entry point and
                // returnTo are still owned here; only the stopping rule moved.
                sessionStorage.removeItem('goLiveWizard.assignNumberOnly')
                localStorage.setItem('goLiveWizard.lastStep', String(step.wizardStep))
            } catch (_e) {
                // Storage may be unavailable in restricted browser modes; the
                // wizard still performs its own context guard after navigation.
            }
        }

        navigate(step.route, {
            replace: Boolean(featureSlug),
            state: step.returnTo ? { returnTo: step.returnTo } : undefined,
        })
    }, [agentId, bussinesId, featureSlug, navigate, steps])

    // Inline "Auto Spam Blocking" toggle — flips autoBlacklistEnabled for this
    // agent via the same API the /contacts Blacklist tab uses. Optimistically
    // updates the card, reverts on failure. Spreads the stored settings so we
    // don't wipe sibling fields (notify preferences, forward number, etc.).
    const handleSpamToggle = useCallback(async (step) => {
        if (spamSaving || !agentId) return
        const next = !step.done
        setSpamSaving(true)
        const setSpamStep = (done) =>
            setSteps((prev) =>
                prev.map((s) =>
                    s.key === 'spamFiltering'
                        ? { ...s, done, value: done ? 'Enabled' : 'Pending' }
                        : s
                )
            )
        setSpamStep(next) // optimistic
        try {
            const updated = { ...spamSettings, autoBlacklistEnabled: next }
            await updateAgentSpamSettings(agentId, updated)
            setSpamSettings(updated)
        } catch (_e) {
            setSpamStep(!next) // revert
            setSequencePopupMessage('Could not update spam filtering. Please try again.')
        } finally {
            setSpamSaving(false)
        }
    }, [agentId, spamSettings, spamSaving])

    // A feature email/webview can open a dedicated Setup Ready URL. Wait for
    // live states to load, then use the exact same guarded click flow as the
    // cards. `replace` above prevents browser Back from reopening and
    // auto-launching the same deep link in a loop.
    useEffect(() => {
        if (loading || !featureSlug || deepLinkHandledRef.current) return
        deepLinkHandledRef.current = true
        const featureKey = FEATURE_KEY_BY_SLUG[featureSlug]
        const step = steps.find((candidate) => candidate.key === featureKey)
        if (step) handleStepAction(step)
        else setSequencePopupMessage('This setup feature is not available.')
    }, [loading, featureSlug, steps, handleStepAction])

    return (
        <div className={styles.container}>
            <div className={styles.backRow}>
                <button
                    type="button"
                    className={styles.backButton}
                    onClick={() => navigate('/fast-agent-detail')}
                    aria-label="Back to dashboard"
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path
                            d="M15 18l-6-6 6-6"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <span>Back</span>
                </button>
            </div>

            {/* Progress ring */}
            <div className={styles.ringWrapper}>
                <svg width={size} height={size} className={styles.ring}>
                    <circle
                        className={styles.ringTrack}
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        strokeWidth={stroke}
                    />
                    <circle
                        className={styles.ringProgress}
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        strokeWidth={stroke}
                        strokeDasharray={circumference}
                        strokeDashoffset={offset}
                    />
                </svg>
                <div className={styles.ringCenter}>
                    <span className={styles.ringPercent}>{Math.round(progress)}%</span>
                    <span className={styles.ringLabel}>complete</span>
                </div>
            </div>

            <h2 className={styles.heading}>Your {agentName} Setup is Almost Ready</h2>
            <p className={styles.subheading}>
                Just a few steps left to unlock your full AI receptionist experience.
            </p>

            {/* Steps grid */}
            {loading ? (
                <p className={styles.subheading}>Loading your setup…</p>
            ) : (
                <div className={styles.grid}>
                    {steps.map((step, index) => {
                        // Configured (done) rows never show "Setup now". Availability
                        // is the only done row that stays editable → "Update".
                        // Everything not-done shows "Setup now" and routes to the
                        // relevant configuration flow.
                        const actionLabel = step.done
                            ? step.updatable
                                ? 'Update'
                                : null
                            : 'Setup now'
                        // Action wale cards (Setup now / Update) poore tap-able —
                        // chhota button akela target tha. Toggle card nahi: wahan
                        // card pe tap se spam on/off nahi hona chahiye.
                        const cardClickable = !step.toggle && !!actionLabel
                        return (
                            <div
                                key={index}
                                className={`${styles.card} ${cardClickable ? styles.cardClickable : ''}`}
                                onClick={cardClickable ? () => handleStepAction(step) : undefined}
                            >
                                <div className={styles.cardHeader}>
                                    <div
                                        className={`${styles.cardIcon} ${step.done ? styles.cardIconDone : styles.cardIconPending}`}
                                    >
                                        {step.icon}
                                        {step.done ? <CheckIcon /> : <PendingIcon />}
                                    </div>
                                    <span className={styles.cardTitle}>{step.title}</span>
                                </div>

                                <div className={styles.cardFooter}>
                                    <span
                                        className={`${styles.cardValue} ${step.done ? styles.valueDone : styles.valuePending
                                            }`}
                                    >
                                        {step.value}
                                        {step.valueStatus}
                                        {step.valueSuffix && (
                                            <span className={styles.valueSuffix}>{step.valueSuffix}</span>
                                        )}
                                    </span>
                                    {step.toggle ? (
                                        <button
                                            type="button"
                                            role="switch"
                                            aria-checked={step.done}
                                            aria-label="Auto spam blocking"
                                            disabled={spamSaving}
                                            className={`${styles.spamToggle} ${step.done ? styles.spamToggleOn : ''}`}
                                            onClick={() => handleSpamToggle(step)}
                                        >
                                            <span className={styles.spamToggleKnob} />
                                        </button>
                                    ) : (
                                        actionLabel && (
                                            // onClick card pe hai; button ka click
                                            // wahin bubble hota hai (keyboard Enter bhi),
                                            // alag handler lagate to action do baar chalta.
                                            <button
                                                type="button"
                                                className={styles.cardAction}
                                            >
                                                {actionLabel}
                                            </button>
                                        )
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>
            )}

            {sequencePopupMessage && (
                <PopUp
                    type="failed"
                    message={sequencePopupMessage}
                    onClose={() => setSequencePopupMessage('')}
                />
            )}
        </div>
    )
}

export default SetUpReady
